module.exports = __webpack_public_path__ + "static/Roboto-Italic-9da6e8b1803fec548ee0720f620f93f5.ttf";